@import '../../styles/color.theme.less';

// ================================================================ //
// -- Theme Definition

:host {

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .fluid-text {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @color: @color-tokens-legacy;
      @text();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @color: @color-tokens-lm;
      @text();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @color: @color-tokens-corp;
      @text();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @color: @color-tokens-corp;
      @text();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@text: {
  font-family: @font-family;
  font-size: @font-size;
  line-height: @line-height;
  color: inherit;
  hyphens: inherit;

  &:not(strong) { // For backward compatibility
    margin-block-start: 1em;
    margin-block-end: 1em;
  }

  // ==== Display

  &.inline {
    display: inline-block;
    padding-right: 0.5em;
  }

  &.block {
    display: block;
  }

  // ==== Font Style

  &.muted {
    font-size: @font-size * 0.9; // Temporary fix until rem units implemented
    color: @liberty-gray-69;
  }

  &.small {
    font-size: @font-size * 0.875; // Temporary fix until rem units implemented
  }

  &.italics {
    font-style: italic;
  }

  &.super {
    vertical-align: super;
  }

  // ==== Remove Margin / Padding

  &.disable-gutters {
    margin: 0;
  }

  &.disable-top-gutter {
    margin-top: 0;
  }

  &.disable-bottom-gutter {
    margin-bottom: 0;
  }

  &.disable-padding {
    padding: 0;
  }

  // ==== Text Alignment

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  // ==== Word Break Behavior

  &.pre-wrap {
    white-space: pre-wrap;
  }

  &.break-word {
    overflow-wrap: break-word;
  }

  // ==== Text Overflow

  &.text-overflow-clip,
  &.text-overflow-ellipsis {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  &.text-overflow-clip {
    text-overflow: clip;
  }

  &.text-overflow-ellipsis {
    text-overflow: ellipsis;
  }

  // ==== Color

  &.blue { color: @color[blue] }
  &.yellow { color: @color[yellow] }
  &.orange { color: @color[orange] }
  &.info { color: @color[info] }
  &.warning { color: @color[warning] }
  &.error { color: @color[error] }
  &.white { color: @color[white] }
  &.gray { color: @color[gray] }
  &.light-gray { color: @color[light-gray] }
  &.success { color: @color[success] }
};
